<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <CoilPlanAndDailyInput v-if='selectedIndex === 0'/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import CoilPlanAndDailyInput from './CoilPlanAndDailyInput'

export default {
  name: 'CoilPlanAndDailyInputTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [
        {
          title: '원자재 계획/입고'
        }
      ]
    }
  },
  components: {
    DxTabPanel,
    CoilPlanAndDailyInput
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
  },
  mounted () {
    // this.$refs.refPurchaseInputPivotComponent.refreshDataGridFromParent('ALL')
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
